import { objectSpread2 as _objectSpread2, taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import { TableMenuDirection } from '../constants.js';
import MenuCellTrigger from './MenuCellTrigger.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import TriggerMenu from '../../menus/base/TriggerMenu.js';

var _templateObject;

var _excluded = ["direction", "as", "triggerComponent", "className"];
var componentRoot = createComponentSlot({
  name: "CinTableMenu",
  slot: "Root"
});

var MenuCellBase = function MenuCellBase(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? TableMenuDirection.Left : _ref$direction,
      as = _ref.as,
      _ref$triggerComponent = _ref.triggerComponent,
      triggerComponent = _ref$triggerComponent === void 0 ? MenuCellTrigger : _ref$triggerComponent,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TriggerMenu, _extends({}, props, {
    direction: direction,
    triggerComponent: as !== null && as !== void 0 ? as : triggerComponent,
    className: classnames(componentRoot.className, className)
  }));
};

MenuCellBase.propTypes = {
  direction: propTypes.any,
  as: propTypes.elementType
};
var MenuCellRoot = styled(MenuCellBase, _objectSpread2(_objectSpread2({}, componentRoot.styledOptions), {}, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "sx";
  } // ensure legacy 'as' prop is forwarded

}))(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * Renders a cell which contains a dropdown menu
 */

var MenuCell = function MenuCell(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(MenuCellRoot, rootProps);
};

var MenuCell$1 = MenuCell;

export { MenuCell$1 as default };
